export default __webpack_public_path__ + "static/media/lottery-orig-copy.7087af9c.png";